import React, { useState, useEffect, useRef } from 'react';
import Layout from '../../components/Layout/index';
import {
    Breadcrumb,
    BreadcrumbItem,
    ModalHeader,
    ModalBody,
    Button,
    Row,
    Col,
    FormGroup,
    Label,
    Input,
    InputGroup,
    Card,
    CardHeader,
    CardBody,
} from 'reactstrap';
import { faDollarSign } from '@fortawesome/free-solid-svg-icons';
import { DropdownList } from 'react-widgets';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import createNotification from '../../utils/createNotification';
import ComingSoonQuotesComponent from './ComingSoonQuotesComponent';
import { ComingSoonQoutes } from './quotes';
import Loader from 'react-loaders';
import { Loader as LoaderAnim } from 'react-loaders';
import { Field, Form, Input as AvialityInput } from '@availity/form';
import * as yup from 'yup';
import Rodal from '../../components/Rodal/Rodal';
import { ArrowDown } from '../../components/arrow-down/arrow-down';
import { HomeButton } from '../../components/HomeButton/home-button';
import { useStateSelector } from '../../store/selectors';
import { PRACTICE_STATUS_ENUM } from '../../utils/constants';
import { PRACTICE_OWNERSHIP_TYPES } from '../../utils/constants/PracticeOwnerType.enum';
import NoPageAccessAlert from '../../components/NoPageAccessAlert/NoPageAccessAlert';
import { useDispatch } from 'react-redux';
import { LoadLimits } from '../../slices/current-user/load-limits.thunk';
import ProcessAboutModal from './ProcessAboutModal/ProcessAboutModal';
import { LoadMarketplaceTemplatePricing } from '../../slices/marketplace/pricing/load-marketplace-pricing.thunk';
import { ComingSoonCommercialTermsCalculator } from './ComingSoonCommercialTermsTable/CommingSoonCommercialTermsCalculator';

const PracticeBrokerageServicesComponant = () => {
    const dispatch = useDispatch();
    const [isVisibleAgreementRequest, setIsAgreementRequestVisible] =
        useState(false);
    const [animation, setAnimation] = useState('slideTop');
    const [practiceList, setPracticeList] = useState([]);
    const [ltmRevenue, setLtmRevenue] = useState();
    const [fte, setFte] = useState();
    const [practiceSyncData, setPracticeSyncData] = useState({});
    const [selectedPractice, setSelectedPractice] = useState('');
    const axios = useStateSelector((state) => state.core.axios);
    const limits = useStateSelector((state) => state.currentUser.limits);
    const [quotes, setQuotes] = useState([]);
    const [loader, setLoader] = useState(false);
    const [isProcessAboutModalVisible, setIsProcessAboutModalVisible] =
        useState(false);
    const [marketplacePricing, setMarketplacePricing] = useState();
    const spinner = <LoaderAnim color="#12345" type="ball-scale-multiple" />;
    const formRef = useRef(null);

    useEffect(() => {
        dispatch(LoadLimits());
        fetchPricing();
        initialLoad();
    }, []);

    useEffect(() => {
        setQuotes(ComingSoonQoutes);
    }, []);

    useEffect(() => {
        if (selectedPractice && selectedPractice !== '-1') {
            const cached = practiceSyncData[selectedPractice];
            if (cached) {
                const fetchedRevenue = cached.ltmRevenue;
                const fetchedFte = cached.fteDvm;

                if (
                    fetchedRevenue !== '' &&
                    fetchedRevenue !== null &&
                    fetchedRevenue !== undefined
                ) {
                    const formattedRevenue = addCommas(
                        removeNonNumeric(fetchedRevenue)
                    );
                    setLtmRevenue(formattedRevenue);
                    formRef.current?.setFieldValue(
                        'ltmRevenue',
                        formattedRevenue,
                        true
                    );
                }

                if (
                    fetchedFte !== '' &&
                    fetchedFte !== null &&
                    fetchedFte !== undefined
                ) {
                    setFte(fetchedFte);
                    formRef.current?.setFieldValue('fte', fetchedFte, true);
                }
                return;
            }

            axios
                .get('/api/Practice/GetPracticeSyncData', {
                    params: { practiceId: selectedPractice },
                })
                .then((response) => {
                    const data = response?.data || {};
                    const fetchedFte = data?.fteDvm ?? data?.FteDvm ?? '';
                    const fetchedRevenue =
                        data?.ltmRevenue ?? data?.LTMRevenue ?? '';

                    if (
                        fetchedRevenue !== '' &&
                        fetchedRevenue !== null &&
                        fetchedRevenue !== undefined
                    ) {
                        const formattedRevenue = addCommas(
                            removeNonNumeric(fetchedRevenue)
                        );
                        setLtmRevenue(formattedRevenue);
                        formRef.current?.setFieldValue(
                            'ltmRevenue',
                            formattedRevenue,
                            true
                        );
                    }

                    if (
                        fetchedFte !== '' &&
                        fetchedFte !== null &&
                        fetchedFte !== undefined
                    ) {
                        setFte(fetchedFte);
                        formRef.current?.setFieldValue('fte', fetchedFte, true);
                    }
                })
                .catch(() => {
                    createNotification(
                        'An error ocurred while processing request.',
                        'error'
                    );
                });
        } else {
            setFte('');
            setLtmRevenue('');
            formRef.current?.setFieldValue('fte', '', true);
            formRef.current?.setFieldValue('ltmRevenue', '', true);
        }
    }, [selectedPractice, practiceSyncData]);

    const fetchPricing = async () => {
        const response = await dispatch(LoadMarketplaceTemplatePricing());
        setMarketplacePricing(
            JSON.parse(JSON.stringify(response.payload.data))
        );
    };

    const initialLoad = () => {
        const loggedInSummary = localStorage.getItem('loggedInUserSummary');
        if (loggedInSummary) {
            let data = JSON.parse(loggedInSummary);

            if (data && data.practices && data.practices.length > 0) {
                const approvedPractices = data.practices.filter(
                    (x) =>
                        x.status === PRACTICE_STATUS_ENUM.Approved &&
                        x.practiceOwnershipType !=
                            PRACTICE_OWNERSHIP_TYPES.FORMER
                );
                if (approvedPractices && approvedPractices.length > 0) {
                    setPracticeList(approvedPractices);
                    prefetchPracticeSyncData(
                        approvedPractices.map((p) => p.id)
                    );
                }
            }
        }
    };

    const prefetchPracticeSyncData = async (ids) => {
        if (!ids || !ids.length) return;
        try {
            const requests = ids.map((id) =>
                axios
                    .get('/api/Practice/GetPracticeSyncData', {
                        params: { practiceId: id },
                    })
                    .then((response) => ({ id, data: response?.data || {} }))
                    .catch(() => ({ id, data: {} }))
            );
            const results = await Promise.all(requests);
            const map = {};
            results.forEach(({ id, data }) => {
                map[id] = {
                    fteDvm: data?.fteDvm ?? data?.FteDvm ?? null,
                    ltmRevenue: data?.ltmRevenue ?? data?.LTMRevenue ?? null,
                };
            });
            setPracticeSyncData(map);
        } catch {
            createNotification(
                'An error ocurred while processing request.',
                'error'
            );
        }
    };

    const addCommas = (num) =>
        num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const removeNonNumeric = (num) => num.toString().replace(/[^0-9]/g, '');

    const onChange = (value) => {
        setLtmRevenue(addCommas(removeNonNumeric(value)));
        formRef.current.setFieldValue(
            'ltmRevenue',
            addCommas(removeNonNumeric(value)),
            true
        );
    };

    const requestComingSoonCommercialTermClick = () => {
        let quo = JSON.parse(JSON.stringify(ComingSoonQoutes));
        quo[0].leftText =
            ComingSoonCommercialTermsCalculator.calculateCommercialTerms(
                fte,
                ltmRevenue,
                quo[0].type,
                marketplacePricing
            );
        quo[1].leftText =
            fte < 2
                ? undefined
                : ComingSoonCommercialTermsCalculator.calculateCommercialTerms(
                      fte,
                      ltmRevenue,
                      quo[1].type,
                      marketplacePricing
                  );
        setQuotes(quo);
    };

    const getAboutTheProcessButton = () => {
        return (
            <div className="about-process-title-wrapper">
                <div className="about-process-title">
                    <div
                        onClick={() => {
                            setIsProcessAboutModalVisible(true);
                        }}>
                        About the Process
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="practice-brokerage-services">
            <Layout>
                {!limits.currentSubscriptionLimitsState
                    .doesBrokerageAvailable ? (
                    <NoPageAccessAlert />
                ) : (
                    <>
                        <div className="title-wrapper">
                            <div className="title-left">
                                <div className="page-title">
                                    <h3>Practice Brokerage Services</h3>
                                </div>
                                <Breadcrumb>
                                    <BreadcrumbItem>
                                        <HomeButton />
                                    </BreadcrumbItem>
                                    <BreadcrumbItem active>
                                        Practice Brokerage Services
                                    </BreadcrumbItem>
                                </Breadcrumb>
                            </div>
                            <div className="title-center">
                                {getAboutTheProcessButton()}
                            </div>
                        </div>

                        <div>
                            <Card className="card-section main-card mb-3">
                                <CardHeader className="card-header">
                                    <span className="practice-heading">
                                        {'Obtain Practice Brokerage Quotes'}
                                    </span>
                                </CardHeader>
                                <CardBody>
                                    <div className="obpbq_row">
                                        <Form
                                            innerRef={formRef}
                                            onSubmit={
                                                requestComingSoonCommercialTermClick
                                            }
                                            initialValues={{
                                                selectedPractice:
                                                    selectedPractice,
                                                ltmRevenue: ltmRevenue,
                                                fte: fte,
                                            }}
                                            validationSchema={yup
                                                .object()
                                                .shape({
                                                    selectedPractice: yup
                                                        .string()
                                                        .required(
                                                            'This field is invalid.'
                                                        ),
                                                    ltmRevenue: yup
                                                        .string()
                                                        .required(
                                                            'LTMRevenue is required.'
                                                        )
                                                        .matches(
                                                            new RegExp(
                                                                /[0-9]/g
                                                            ),
                                                            'Enter valid LTM Revenue.'
                                                        ),
                                                    fte: yup
                                                        .number()
                                                        .required(
                                                            'FTE is required.'
                                                        ),
                                                })}>
                                            <Row>
                                                <Col md={7}>
                                                    <FormGroup className="mb-0">
                                                        <Label for="txtGrowPractice">
                                                            Select Practice
                                                        </Label>
                                                        <div className="mb-0">
                                                            <AvialityInput
                                                                type="select"
                                                                name="selectedPractice"
                                                                onChange={(e) =>
                                                                    setSelectedPractice(
                                                                        e.target
                                                                            .value
                                                                    )
                                                                }>
                                                                <option
                                                                    key="0"
                                                                    value="-1">
                                                                    Select
                                                                </option>
                                                                {practiceList
                                                                    ? practiceList.map(
                                                                          (
                                                                              option,
                                                                              index
                                                                          ) => (
                                                                              <option
                                                                                  key={
                                                                                      index
                                                                                  }
                                                                                  value={
                                                                                      option.id
                                                                                  }>
                                                                                  {
                                                                                      option.name
                                                                                  }
                                                                              </option>
                                                                          )
                                                                      )
                                                                    : ''}
                                                            </AvialityInput>
                                                        </div>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={1}>
                                                    <FormGroup className="mb-0">
                                                        <Label for="LTM Revenue">
                                                            LTM Revenue
                                                        </Label>
                                                        <div className="mb-0">
                                                            <InputGroup
                                                                className="mb-3"
                                                                style={{
                                                                    display:
                                                                        'flex',
                                                                }}>
                                                                <div class="ltmRevenue input-group-prepend">
                                                                    <div className="input-group-text input-adornment-icon">
                                                                        <FontAwesomeIcon
                                                                            icon={
                                                                                faDollarSign
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <Field
                                                                    type="text"
                                                                    name="ltmRevenue"
                                                                    onChange={(
                                                                        event
                                                                    ) =>
                                                                        onChange(
                                                                            event
                                                                                .target
                                                                                .value
                                                                        )
                                                                    }
                                                                    id="txtRevenue"
                                                                    className="form-control input-adornment"
                                                                />
                                                            </InputGroup>
                                                        </div>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={1}>
                                                    <FormGroup className="mb-0">
                                                        <Label for="Grow practice">
                                                            # of FTE w-2 DVMs
                                                        </Label>
                                                        <div className="mb-0">
                                                            <Field
                                                                type="number"
                                                                name="fte"
                                                                onChange={(
                                                                    event
                                                                ) =>
                                                                    setFte(
                                                                        event
                                                                            .target
                                                                            .value
                                                                    )
                                                                }
                                                                id="txtFTE"
                                                            />
                                                        </div>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={2}>
                                                    <FormGroup className="mb-0">
                                                        <InputGroup className="mt-4">
                                                            <Button
                                                                className="btn btn-primary btn__RCT"
                                                                type="submit">
                                                                Request
                                                                Commercial Terms
                                                            </Button>
                                                        </InputGroup>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </div>
                                </CardBody>
                            </Card>

                            {loader ? (
                                <div
                                    className="loader-container"
                                    style={{ height: '100%', width: '100%' }}>
                                    <div className="loader-container-inner">
                                        <br />
                                        <div className="text-center">
                                            <Loader
                                                show={loader}
                                                message={spinner}
                                            />
                                        </div>
                                        <h6 className="mt-5">Loading...</h6>
                                    </div>
                                </div>
                            ) : (
                                quotes.map((value, _) => (
                                    <ComingSoonQuotesComponent
                                        data={value}
                                        practice={practiceList.find(
                                            (p) => p.id == selectedPractice
                                        )}
                                        marketplacePricing={marketplacePricing}
                                        fteW2Dvms={fte}
                                        ltmRevenue={ltmRevenue}
                                        hasPaidSubscription={
                                            limits.hasPaidSubscription
                                        }
                                    />
                                ))
                            )}
                        </div>

                        <Rodal
                            visible={isVisibleAgreementRequest}
                            onClose={() => {
                                setIsAgreementRequestVisible(false);
                            }}
                            animation={animation}
                            showMask={true}
                            width={498}
                            showCloseButton={true}>
                            <ModalHeader>
                                Engagement Agreement Request Form
                            </ModalHeader>
                            <ModalBody className="tab_wrapper_modal pmg_placement_popup">
                                <div className="call_time_info">
                                    <Row>
                                        <Col md={12}>
                                            <FormGroup>
                                                <Label for="BusinessName">
                                                    Practice Legal Business Name
                                                </Label>
                                                <InputGroup className="mb-2">
                                                    <Input
                                                        type="phone"
                                                        id="BusinessName"
                                                        className="form-control"
                                                        name="business-name"
                                                        value={''}
                                                    />
                                                </InputGroup>
                                            </FormGroup>
                                        </Col>
                                        <Col md={12}>
                                            <FormGroup>
                                                <Label for="PracticeDBA">
                                                    Practice D/B/A
                                                </Label>
                                                <InputGroup className="mb-2">
                                                    <Input
                                                        type="phone"
                                                        id="PracticeDBA"
                                                        className="form-control"
                                                        name="PracticeDBA"
                                                        value={''}
                                                    />
                                                </InputGroup>
                                            </FormGroup>
                                        </Col>
                                        <Col md={12}>
                                            <FormGroup className="mt-2">
                                                <Row className="align-items-center">
                                                    <Col>
                                                        <Label for="">
                                                            Form of Legal Entity
                                                        </Label>
                                                    </Col>
                                                    <Col>
                                                        <div className="mb-3">
                                                            <DropdownList
                                                                selectIcon={
                                                                    <ArrowDown />
                                                                }
                                                                data={[
                                                                    {
                                                                        name: 'LLC',
                                                                        id: 1,
                                                                    },
                                                                    {
                                                                        name: 'C-Corporation',
                                                                        id: 2,
                                                                    },
                                                                    {
                                                                        name: 'S-Corporation',
                                                                        id: 3,
                                                                    },
                                                                    {
                                                                        name: 'Professional Corporation',
                                                                        id: 4,
                                                                    },
                                                                    {
                                                                        name: 'LP (limited Partnership)',
                                                                        id: 5,
                                                                    },
                                                                ]}
                                                                dataKey="id"
                                                                textField="name"
                                                                placeholder="LLC"
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </FormGroup>
                                        </Col>
                                        <Col md={12}>
                                            <FormGroup className="mt-2">
                                                <Row className="align-items-center">
                                                    <Col>
                                                        <Label for="">
                                                            State of Legal
                                                            Entity Registration
                                                        </Label>
                                                    </Col>
                                                    <Col lg={4}>
                                                        <div className="mb-3">
                                                            <DropdownList
                                                                selectIcon={
                                                                    <ArrowDown />
                                                                }
                                                                data={[
                                                                    {
                                                                        name: 'LLC',
                                                                        id: 1,
                                                                    },
                                                                    {
                                                                        name: 'C-Corporation',
                                                                        id: 2,
                                                                    },
                                                                    {
                                                                        name: 'S-Corporation',
                                                                        id: 3,
                                                                    },
                                                                    {
                                                                        name: 'Professional Corporation',
                                                                        id: 4,
                                                                    },
                                                                    {
                                                                        name: 'LP (limited Partnership)',
                                                                        id: 5,
                                                                    },
                                                                ]}
                                                                dataKey="id"
                                                                textField="name"
                                                                placeholder="Select"
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </FormGroup>
                                        </Col>
                                        <Col md={12}>
                                            <FormGroup>
                                                <Label for="address">
                                                    Practice Street Address
                                                </Label>
                                                <InputGroup className="mb-2">
                                                    <Input
                                                        type="text"
                                                        id="address"
                                                        className="form-control"
                                                        name="address"
                                                        value={''}
                                                    />
                                                </InputGroup>
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="city">City</Label>
                                                <InputGroup className="mb-2">
                                                    <Input
                                                        type="text"
                                                        id="city"
                                                        className="form-control"
                                                        name="city"
                                                        value={''}
                                                    />
                                                </InputGroup>
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="state">State</Label>
                                                <div className="mb-2">
                                                    <DropdownList
                                                        selectIcon={
                                                            <ArrowDown />
                                                        }
                                                        data={[
                                                            {
                                                                name: 'State Name',
                                                                id: 1,
                                                            },
                                                            {
                                                                name: 'State Name',
                                                                id: 2,
                                                            },
                                                            {
                                                                name: 'State Name',
                                                                id: 3,
                                                            },
                                                            {
                                                                name: 'State Name',
                                                                id: 4,
                                                            },
                                                            {
                                                                name: 'State Name',
                                                                id: 5,
                                                            },
                                                        ]}
                                                        dataKey="id"
                                                        textField="name"
                                                        placeholder="Select"
                                                    />
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="zipcode">
                                                    Zip Code
                                                </Label>
                                                <InputGroup className="mb-2">
                                                    <Input
                                                        type="number"
                                                        id="zipcode"
                                                        className="form-control"
                                                        name="pin code"
                                                        value={''}
                                                    />
                                                </InputGroup>
                                            </FormGroup>
                                        </Col>
                                        <Col md={12}>
                                            <FormGroup>
                                                <Label for="owner">
                                                    Owner (as name should appear
                                                    in document)
                                                </Label>
                                                <InputGroup className="mb-2">
                                                    <Input
                                                        type="text"
                                                        id="owner"
                                                        className="form-control"
                                                        name="owner"
                                                        value={''}
                                                    />
                                                </InputGroup>
                                            </FormGroup>
                                            <FormGroup className="text-right">
                                                <button className="btn btn-primary btn-sm">
                                                    Add Owner
                                                </button>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <hr />
                                    <Row>
                                        <Col md={12}>
                                            <FormGroup>
                                                <Label for="Designated1">
                                                    Designated Contact For
                                                    Notices
                                                </Label>
                                                <InputGroup className="mb-2">
                                                    <Input
                                                        type="text"
                                                        id="Designated1"
                                                        className="form-control"
                                                        name="Designated"
                                                        value={''}
                                                    />
                                                </InputGroup>
                                            </FormGroup>
                                        </Col>
                                        <Col md={12}>
                                            <FormGroup>
                                                <Label for="ContactAddress1">
                                                    Contact Street Address
                                                </Label>
                                                <InputGroup className="mb-2">
                                                    <Input
                                                        type="text"
                                                        id="ContactAddress1"
                                                        className="form-control"
                                                        name="ContactAddress"
                                                        value={''}
                                                    />
                                                </InputGroup>
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="city1">City</Label>
                                                <InputGroup className="mb-2">
                                                    <Input
                                                        type="text"
                                                        id="city1"
                                                        className="form-control"
                                                        name="city"
                                                        value={''}
                                                    />
                                                </InputGroup>
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="state1">
                                                    State
                                                </Label>
                                                <div className="mb-2">
                                                    <DropdownList
                                                        selectIcon={
                                                            <ArrowDown />
                                                        }
                                                        data={[
                                                            {
                                                                name: 'State Name',
                                                                id: 1,
                                                            },
                                                            {
                                                                name: 'State Name',
                                                                id: 2,
                                                            },
                                                            {
                                                                name: 'State Name',
                                                                id: 3,
                                                            },
                                                            {
                                                                name: 'State Name',
                                                                id: 4,
                                                            },
                                                            {
                                                                name: 'State Name',
                                                                id: 5,
                                                            },
                                                        ]}
                                                        dataKey="id"
                                                        textField="name"
                                                        placeholder="Select"
                                                    />
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="zipcode1">
                                                    Zip Code
                                                </Label>
                                                <InputGroup className="mb-2">
                                                    <Input
                                                        type="number"
                                                        id="zipcode1"
                                                        className="form-control"
                                                        name="pincode"
                                                        value={''}
                                                    />
                                                </InputGroup>
                                            </FormGroup>
                                        </Col>
                                        <Col md={12}>
                                            <div className="submit_bnt_wrapper text-right mt-2">
                                                <button
                                                    className="btn btn-primary"
                                                    type="submit">
                                                    Submit
                                                </button>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </ModalBody>
                        </Rodal>
                    </>
                )}
                {isProcessAboutModalVisible ? (
                    <ProcessAboutModal
                        isVisible={isProcessAboutModalVisible}
                        closeModal={() => {
                            setIsProcessAboutModalVisible(false);
                        }}></ProcessAboutModal>
                ) : (
                    <></>
                )}
            </Layout>
        </div>
    );
};

export default PracticeBrokerageServicesComponant;
